import { makeAutoObservable, toJS } from "mobx";
import backend from './backend'
import ui from './ui'




class DataStore {
  resData: backend.ResData = {};
  ews: WebSocket | null = null;

  constructor () {
    makeAutoObservable(this);
  }

  setEws = (ws: WebSocket | null) => {
    this.ews = ws;
  };

  setData = (data: backend.ActionData) => {
    const action = data.action as any;
    let payload: any = data.data;

    const objectRequiredActions = new Set([
      'activeLogAck',
      'defaultAck',
      'loadSettingAck',
      'loadNavStatusAck',
    ]);

    const isInvalidObjectPayload = !payload || Array.isArray(payload) || typeof payload !== 'object';

    // 关键保护：若已有有效对象，后续异常包（[]/null）不允许覆盖
    if (objectRequiredActions.has(action)) {
      const current = (this.resData as any)[action];
      const currentValid = current && !Array.isArray(current) && typeof current === 'object';
      if (currentValid && isInvalidObjectPayload) {
        return;
      }
    }

    // 兼容异常返回：activeLogAck 可能偶发是 [] / null，统一兜底成可渲染结构
    if (action === 'activeLogAck' && isInvalidObjectPayload) {
      payload = {
        state: 'DRAFT',
        draftProgram: { steps: [] },
        activeProgram: { steps: [] },
      };
    }

    if (action === 'defaultAck' && isInvalidObjectPayload) {
      payload = {};
    }

    // recipesAck 的稳定形态是数组；若偶发收到数字键对象，这里再兜底还原成数组。
    if (action === 'recipesAck' && payload && !Array.isArray(payload) && typeof payload === 'object') {
      const numericKeys = Object.keys(payload).filter((key) => /^\d+$/.test(key)).sort((a, b) => Number(a) - Number(b));
      if (numericKeys.length) {
        payload = numericKeys.map((key) => payload[key]);
      }
    }

    (this.resData as any)[action] = payload;
    //console.log('setData', data)
  };

  clearData = (action: backend.ActionData['action']) => {
    (this.resData as any)[action] = undefined
  };

  setNav = (data: backend.Nav['data']) => {
    this.resData['nav'] = data
  }

  sendData = (data: ui.ActionData) => {

    if (!this.ews) return;

    const mode = (process.env.REACT_APP_RUNTIME_MODE || 'kiosk').toLowerCase();

    // cloud 模式下，所有 UI 控制通过 cloud 中枢转发到 kiosk
    if (mode === 'cloud') {
      const targetMachineId = (window as any).__HB_TARGET_MACHINE_ID__ || process.env.REACT_APP_TARGET_MACHINE_ID || process.env.REACT_APP_MACHINE_ID || 'kiosk-001';
      const webId = (window as any).__HB_WEB_CLIENT_ID__ || process.env.REACT_APP_CLOUD_WEB_ID || 'cloud-web-001';
      this.ews.send(JSON.stringify({
        type: 'COMMAND',
        requestId: `web_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
        timestamp: Date.now(),
        from: webId,
        to: targetMachineId,
        data: {
          ...data,
          machineId: targetMachineId,
        },
      }));
      return;
    }

    this.ews.send(JSON.stringify(data));
  };
}

export default DataStore;
